import React from "react";
import "./Glossary.scss";
import { useLocation } from "react-router-dom";
import HeaderNavigate from "../../components/headerNavigate/HeaderNavigate";
import { useCustomSearchParams } from "../../components/hooks/useCustomSearchParams";
import { SEARCH_PARAMS } from "../../utils/SearchParams";
import ImageContainer from "../../components/imageContainer/ImageContainer";

const glossaryData = [
  {
    title: "Funder Portal URLs",
    description:
      "Number of DOIs that has found to be on an funder partners portal.",
  },
  {
    title: "Archived",
    description:
      "Number of CHORUS publisher member DOIs funded by CHORUS Funding Agency Partners and ingested for preservation in CLOCKSS or Portico.",
  },
  {
    title: "ORCID IDs",
    description:
      "Number of DOIs with at least one ORCID ID registered at ORCID.",
  },
  {
    title: "Verified OA on publisher site",
    description: "Number of DOIs recorded as open access on publisher sites.",
  },
  {
    title: "Reuse terms available",
    description:
      "Number of DOIs found to have reuse license terms available in the Crossref metadata.",
  },
  {
    title: "Datasets",
    description:
      "Number of DOIs with at least one datasets as indicated by Scholix DLI Services.",
  },
];

const Glossary = () => {
  const location = useLocation();
  const { get, set } = useCustomSearchParams();
  const funderName = location.state?.funderName || "Funder";

  return (
    <div className="glossary-page">
      <HeaderNavigate
        label={`Funder Dashboard / ${
          get(SEARCH_PARAMS.ENTITY_NAME) || funderName
        }`}
      />

      <div className="content-wrapper">
        <div className="bg-light text-start py-4 px-3 mb-4">
          <h4 className="text-muted m-0">
            {get(SEARCH_PARAMS.ENTITY_NAME)}
            {/* The Commonwealth Scientific and Industrial Research Organisation */}
          </h4>
        </div>

        <div className="glossary-section">
          <h4 className="section-title">Glossary</h4>

          <div className="glossary-grid">
            {glossaryData.map((item, index) => (
              <div key={index} className="glossary-card">
                <h5 className="card-title">{item.title}</h5>
                <p className="card-description">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* <div className="my-5 mx-auto me-3">
   <ImageContainer />
 </div> */}
    </div>
  );
};

export default Glossary;
